(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document
    .querySelector('.header__icon--search')
    .addEventListener('click', function(event) {
      event.preventDefault();
      window.location.href = '/search?q=';
    });

  } catch(e) { console.error(e); }
})();
})();
